import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ProductService } from '../services/product.service';
import { IProduct } from '../interfaces/product';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from '../appSettings';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { AppFormat } from '../appFormat';
import { IOption } from '../interfaces/option';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from '../services/category.service';

import { ICategory } from '../interfaces/category';
import { ISubcategory } from '../interfaces/subcategory';
import { IPacking } from '../interfaces/packing';

import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { ApiService } from '../services/api.service';
import { IImage } from '../interfaces/image';
import { ISubcategories } from '../interfaces/subcategories';
import { SubcategoriaItemComponent } from '../components/subcategoria-item/subcategoria-item.component';
import { OperadorService } from '../services/operador.service';
import { NavigationService } from '../services/navigation-service.service';
import { ProductOffersComponent } from '../components/product-offers/product-offers.component';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: [
    './product.component.scss',
    '../../../node_modules/quill/dist/quill.snow.css',
    '../../../node_modules/quill/dist/quill.bubble.css',
  ],
  host: { class: 'wrapper-product' },
  encapsulation: ViewEncapsulation.None,
})
export class ProductComponent implements OnInit, AfterViewInit {
  @ViewChild(SubcategoriaItemComponent)
  subcategoriaItem: SubcategoriaItemComponent;

  @ViewChild(ProductOffersComponent) productOffersItem: ProductOffersComponent;

  public codebar = {
    format: 'EAN',
    lineColor: '#000000',
    width: 2,
    height: 200,
    displayValue: true,
    font: 'monospace',
    textAlign: 'center',
    textPosition: 'bottom',
    textMargin: 2,
    fontSize: 20,
    background: '#ffffff',
    margin: 10,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
  };

  public categorias: ICategory[] = [];
  public subcategorias: ISubcategory[] = [];

  public embalagens: IPacking[] = [];
  public unidades = [
    { label: 'L', unidade: 'l' },
    { label: 'ml', unidade: 'ml' },
    { label: 'Kg', unidade: 'kg' },
    { label: 'g', unidade: 'g' },
  ];
  public formas_de_venda = [
    { label: 'Unidade', unidade: 'U' },
    { label: 'Kg', unidade: 'Kg' },
  ];
  public formas_de_venda_mostra = [
    { label: 'Por unidade', unidade: 'U' },
    { label: 'Por peso', unidade: 'Kg' },
  ];

  public loading: boolean = false;
  public loadingProduct: boolean = false;

  public step: number = 1;

  public tab: string = 'informacoes';
  private _codbarra: string = '';
  private _id: number = null;

  public errorFindCodbar: boolean = false;

  public isAdmin: boolean = false;
  public isView: boolean = false;
  public product: IProduct;
  public photo_number: number = 1;

  public URL_IMG_PRODUTO: string = AppSettings.URL_IMG_PRODUTO;

  //public categories: ICategory[] = []
  public categories: FormArray;
  public changeDepartamentos: boolean = false;

  public produtoFrm: FormGroup;

  public ckStatus: FormControl;
  public ckAmadurecimento: FormControl;

  public preco: FormControl;
  public estoque: FormControl;
  public codbarra: FormControl;
  public detalhe: FormControl;
  public sem_limite: FormControl;
  public limite_minimo_estoque: FormControl;

  public keywords: FormControl;
  public descricao: FormControl;
  public subtitulo: FormControl;
  public relevancia: FormControl;

  //change
  public idcategoria: FormControl;
  public idsubcategoria: FormControl;

  public marca: FormControl;
  public embalagem: FormControl;
  public peso_liquido: FormControl;
  public unidade_peso_liquido: FormControl;
  public forma_venda: FormControl;
  public forma_venda_mostra: FormControl;
  public max_pr_cliente: FormControl;

  public ckChangePrice: FormControl;
  // public ckPromocao: FormControl;
  public ckFrete: FormControl;
  public importado: FormControl;
  public fabricacao: FormControl;

  // public oferta_preco: FormControl;
  // public oferta_obs: FormControl;
  // public oferta_validade_inicial: FormControl;
  // public oferta_validade_final: FormControl;
  // public oferta_validade_inicial_hora: FormControl;
  // public oferta_validade_final_hora: FormControl;
  // public option_validade_inicial: FormControl;
  // public option_validade_final: FormControl;
  // public oferta_max_pr_cliente: FormControl;
  // public oferta_comprando: FormControl;
  // public oferta_multiplo: FormControl;

  public codigo_interno: FormControl;

  public refrigerado: FormControl;

  public image_subtitle: FormControl;

  public vivino_code: FormControl;
  public vivino_safra: FormControl;

  // public permanencia_inicio: IOption[] = [];
  // public permanencia_fim: IOption[] = [];

  public fabricacao_select: IOption[] = [];

  public lower_stock: number = 3;
  public oferta_off: number = 0;

  public changeDetail: boolean = false;
  public hasOffer: boolean = false;
  public hasLowerStoke: boolean = false;
  public hasOutOfStock: boolean = false;

  public isWine: boolean = true;

  public describeVisible: boolean = false;

  // public minDate = new Date();
  // public startDate = new Date();

  public gallery: IImage[] = [];
  public image_sel_src: string = '';

  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;

  public fileView: any = null;
  public fileViewIdx: any = null;
  public fileImageIdx: any = null;
  public isFileView: boolean = false;
  public isImageView: boolean = false;
  public isImageChange: boolean = false;
  public changeImage: boolean = false;
  public numberPhoto: number = 0;
  public image_sel_hash: string = '';

  private estoque_bk;

  constructor(
    private _productService: ProductService,
    private _operadorService: OperadorService,
    private _categoryService: CategoryService,
    private _route: ActivatedRoute,
    private _apiService: ApiService,
    private navigation: NavigationService
  ) {
    /**
     *
     * envio das fotos
     *
     */

    this.uploader = new FileUploader({
      url: _apiService.API_PATH,
      queueLimit: 5,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item /*{File|FileLikeObject}*/, options) {
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.changeImage) {
        this.saving();
        this.sendImages();
      } else {
        this.onChangeDetail();

        setTimeout(() => {
          let idx = this.uploader.queue.length - 1;
          this.selectImageView(this.uploader.queue[idx], idx);
        }, 600);
      }
    };

    this.uploader.onBeforeUploadItem = (fileItem: any) => {
      if (this.changeImage) {
        let number = 1;
        if (this.gallery[this.fileImageIdx]['padrao'] == 'E') {
          number = this.gallery[this.fileImageIdx].number;
        } else {
          //se o item a substituir for padrao ele procura se existe algum E
          number = 0;
          for (let i in this.gallery) {
            if (this.gallery[i]['padrao'] == 'E') {
              //pega o ultimo numero E.. e acrescenta um valor
              if (number <= this.gallery[i].number) {
                number = parseInt(this.gallery[i].number.toString());
              }
            }
          }
          number = number + 1;
        }
        fileItem.options.additionalParameter = {
          number: number,
          idproduto_geral: this.product.idproduto_geral,
          change: true,
        };
      } else {
        //this.numberPhoto = this.numberPhoto + 1

        let number = 0;
        for (let i in this.gallery) {
          if (this.gallery[i]['padrao'] == 'E') {
            //pega o ultimo numero E.. e acrescenta um valor
            if (number <= this.gallery[i].number) {
              number = parseInt(this.gallery[i].number.toString());
            }
          }
        }
        number = number + 1;

        fileItem.options.additionalParameter = {
          number: number,
          idproduto_geral: this.product.idproduto_geral,
          legenda: fileItem.formData[0]['legenda'],
        };
      }
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          if (this.changeImage) {
            //responsePath['url']

            this.gallery[this.fileImageIdx] = responsePath['url'];
            this.gallery[this.fileImageIdx].hash = AppFormat.makeid(5);
            this.image_sel_hash = AppFormat.makeid(5);
            this.changeImage = false;
          } else {
            //console.log(AppSettings.URL_IMG_PROJECTS+this.idproject+'/'+responsePath['name'])
            this.gallery.push(responsePath['url']);
          }
        }
      }

      //this.numberPhoto = this.numberPhoto + 1
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.numberPhoto = this.gallery.length;
      this.saveComplete();
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      //console.log(item)

      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      //console.log(item);
      //console.log(filter);
      //console.log(options);

      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };

    /**
     *
     */

    this.initProduct();

    // let option_hoje = { text: 'Hoje', value: 'H' };
    // this.permanencia_inicio.push(option_hoje);
    // //this.permanencia_fim.push(option_hoje)

    // let option_nodia = { text: 'No dia', value: 'D' };
    // this.permanencia_inicio.push(option_nodia);
    // this.permanencia_fim.push(option_nodia);

    //
    this.fabricacao_select.push({ text: 'Industrializado', value: 'I' });
    this.fabricacao_select.push({ text: 'Fabricação própria', value: 'F' });
    this.fabricacao_select.push({ text: 'Marca própria', value: 'M' });

    this._categoryService.getAll().subscribe((res) => {
      this.categorias = res.categorias;
    });

    this._productService.getPackaging().subscribe((res) => {
      this.embalagens = res.packaging;
    });
  }

  initProduct(): void {
    this.product = {
      idproduto_estabelecimento: 0,
      idproduto_geral: 0,
      descricao: '',
      marca: '',
      embalagem: '',
      peso_liquido: 0,
      unidade_peso_liquido: '',
    };
    this.estoque_bk = null;
    this.changeDepartamentos = false;
  }

  public addNewCategory() {
    this.categories.push(
      new FormGroup({
        categoria: new FormControl(null),
        list: new FormControl([]),
        showText: new FormControl(false),
        subcategorias: new FormArray([]),
      })
    );
  }

  public addNewSubcategory(frm: FormArray) {
    frm.push(
      new FormGroup({
        subcategoria: new FormControl(null),
        list: new FormControl([]),
        showText: new FormControl(false),
        subcategorias: new FormArray([]),
      })
    );
  }

  public removeCategoria(i: number) {
    Swal.fire({
      title: 'Você deseja remover a categoria do produto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value && this.categories.controls.length > 1) {
        this.categories.controls.splice(i, 1);
        this.onChangeDepartamento();
      }
    });
  }

  public removeSubcategoria(frm: FormArray, j) {
    Swal.fire({
      title: 'Você deseja remover a subcategoria do produto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value && frm.controls.length > 1) {
        frm.controls.splice(j, 1);
        this.onChangeDepartamento();
      }
    });
  }

  public resetSubcategoria(categoria: FormGroup) {
    categoria.controls.subcategorias = new FormArray([]);
  }

  public newCategory(frm: FormGroup) {
    frm.controls.categoria.setValue(null);
    let status = frm.controls.showText.value;
    frm.controls.showText.setValue(!status);
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  selectImageView(file, idx): void {
    this.fileViewIdx = idx;
    this.fileImageIdx = null;
    this.fileView = file;
    this.isFileView = true;
    this.isImageView = false;

    if (!this.fileView.formData[0]) {
      this.fileView.formData.push({ legenda: '' });
    }

    this.image_subtitle.setValue(
      this.fileView.formData[0]['legenda']
        ? this.fileView.formData[0]['legenda']
        : ''
    );
  }

  selectPhoto(image: IImage, i: number) {
    this.image_sel_src = image.default;
    this.isImageView = true;
    this.isFileView = false;
    this.fileImageIdx = i;
    this.fileViewIdx = null;
    this.isImageChange =
      this.gallery[i]['idestabelecimento'] == this.product.idestabelecimento;

    this.image_subtitle.setValue(image.legenda ? image.legenda : '');
  }

  ajustUrl(url) {
    return url.replace(
      AppSettings.URL_IMG_PRODUTO,
      AppSettings.URL_S3_IMG_PRODUTO
    );
  }

  addMoreImage(): void {
    this.changeImage = false;
    this.isFileView = false;
    this.isImageView = false;
    this.fileView = this.fileViewIdx = this.fileImageIdx = null;
    this.image_subtitle.setValue('');
  }

  onChangeSubtitle(): void {
    if (this.fileImageIdx == null) {
      //new file
      this.fileView.formData[0]['legenda'] = this.image_subtitle.value;
    } else {
      this.gallery[this.fileImageIdx]['legenda'] = this.image_subtitle.value;
    }
    this.onChangeDetail();
  }

  onRemoveFileImage(): void {
    Swal.fire({
      title: 'Você deseja excluir a imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this.fileView.remove();
        this.addMoreImage();
      }
    });
  }

  onChangeImage(): void {
    Swal.fire({
      title: 'Você deseja realizar a troca da imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        this.changeImage = true;
        let el: HTMLElement = document.getElementById(
          'fileUploader'
        ) as HTMLElement;
        el.click();
      }
    });
  }

  onRemoveImage(): void {
    Swal.fire({
      title: 'Você deseja excluir a imagem?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Excluindo...',
          icon: 'info',
          showCancelButton: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
        });

        if (
          this.gallery[this.fileImageIdx]['padrao'] &&
          this.gallery[this.fileImageIdx]['padrao'] == 'P'
        ) {
          Swal.fire({
            title: 'Excluida!',
            icon: 'success',
            text: 'A imagem foi excluida',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            heightAuto: false,
          });

          for (let i in this.gallery) {
            this.gallery[i].hash = AppFormat.makeid(5);
          }
          this.image_sel_hash = AppFormat.makeid(5);

          this.numberPhoto = this.numberPhoto - 1;

          this.gallery.splice(this.fileImageIdx, 1);

          this.addMoreImage();

          this.onChangeDetail();
        } else {
          this._productService
            .removeImage(
              this.product.codbarra,
              this.gallery[this.fileImageIdx].number,
              this.product.idproduto_geral,
              this.gallery[this.fileImageIdx]['idestabelecimento']
            )
            .subscribe((res) => {
              Swal.fire({
                title: 'Excluida!',
                icon: 'success',
                text: 'A imagem foi excluida',
                showCancelButton: false,
                allowOutsideClick: true,
                showConfirmButton: true,
                heightAuto: false,
              });

              this.gallery.splice(this.fileImageIdx, 1);

              let c = 1;
              for (let i in this.gallery) {
                if (
                  this.gallery[i]['padrao'] &&
                  this.gallery[i]['padrao'] == 'E'
                ) {
                  this.gallery[i].number = c;
                  ++c;
                }
                this.gallery[i].hash = AppFormat.makeid(5);
              }
              this.image_sel_hash = AppFormat.makeid(5);

              this.numberPhoto = this.numberPhoto - 1;

              this.addMoreImage();

              this.onChangeDetail();
            });
        }
      }
    });
  }

  onChangeCategoria(
    categoria: FormGroup,
    i: number = 0,
    add: boolean = true
  ): void {
    this.resetSubcategoria(categoria);
    this._categoryService
      .getSubcategoriesFrom(categoria.controls.categoria.value)
      .subscribe((res) => {
        categoria.controls.list.setValue(res.subcategorias);
        this.onChangeDepartamento();

        if (res.subcategorias.length > 0 && add) {
          this.addNewSubcategory(<FormArray>categoria.controls.subcategorias);
        }

        this.subcategoriaItem.realoadSubcategoria(i);
      });
  }

  ngOnInit(): void {
    let operador = this._operadorService.getOperador();
    this.isAdmin = operador.sc_tipo == 'A';

    this.createFormControls();
    this.createForm();

    this.loading = true;
    this._route.params.subscribe((data) => {
      if (data['id'] !== undefined) {
        this._id = data['id'];
        this.getProductID(data['id']);
      } else {
        this.loading = false;
      }
    });
  }

  ngAfterViewInit() {
    this.productOffersItem.clear();
  }

  createFormControls() {
    this.preco = new FormControl('', [Validators.required]);
    this.estoque = new FormControl(null);

    this.codbarra = new FormControl('', [Validators.required]);
    this.descricao = new FormControl('', [Validators.required]);

    this.ckAmadurecimento = new FormControl(false);
    this.ckStatus = new FormControl(true);
    this.sem_limite = new FormControl(false);
    this.limite_minimo_estoque = new FormControl(null);
    this.max_pr_cliente = new FormControl(null);

    // this.ckPromocao = new FormControl(false);
    this.ckFrete = new FormControl(false);
    this.importado = new FormControl(false);
    this.ckChangePrice = new FormControl(false);

    this.vivino_code = new FormControl(null);
    this.vivino_safra = new FormControl(null);

    this.subtitulo = new FormControl('');
    this.relevancia = new FormControl(0);

    this.codigo_interno = new FormControl('');

    //
    //this.idcategoria = new FormControl('')
    //this.idsubcategoria = new FormControl('')

    this.categories = new FormArray([]);
    this.addNewCategory();

    //
    this.marca = new FormControl('');
    this.embalagem = new FormControl('');
    this.peso_liquido = new FormControl('');
    this.unidade_peso_liquido = new FormControl(null);
    this.detalhe = new FormControl('');
    this.forma_venda = new FormControl('U');
    this.forma_venda_mostra = new FormControl('U');
    this.keywords = new FormControl('');

    this.image_subtitle = new FormControl('');

    //
    this.fabricacao = new FormControl('');

    //
    // this.oferta_preco = new FormControl('');
    // this.oferta_obs = new FormControl('');
    // this.oferta_validade_inicial = new FormControl('');
    // this.oferta_validade_final = new FormControl('');
    // this.oferta_max_pr_cliente = new FormControl(null);
    // this.oferta_comprando = new FormControl(null);
    // this.oferta_multiplo = new FormControl('N');

    // this.oferta_validade_inicial_hora = new FormControl('00:00:00');
    // this.oferta_validade_final_hora = new FormControl('23:59:59');

    // //
    // this.option_validade_inicial = new FormControl('');
    // this.option_validade_final = new FormControl('');

    this.refrigerado = new FormControl('');
  }

  createForm() {
    this.produtoFrm = new FormGroup({
      preco: this.preco,
      estoque: this.estoque,
      codbarra: this.codbarra,
      ckStatus: this.ckStatus,
      detalhe: this.detalhe,
      // ckPromocao: this.ckPromocao,
      ckAmadurecimento: this.ckAmadurecimento,
      max_pr_cliente: this.max_pr_cliente,
      // oferta_preco: this.oferta_preco,
      // oferta_obs: this.oferta_obs,
      // oferta_validade_inicial: this.oferta_validade_inicial,
      // oferta_validade_final: this.oferta_validade_final,
      // oferta_max_pr_cliente: this.oferta_max_pr_cliente,
      // oferta_comprando: this.oferta_comprando,
      // option_validade_inicial: this.option_validade_inicial,
      // option_validade_final: this.option_validade_final,
      // oferta_validade_inicial_hora: this.oferta_validade_inicial_hora,
      // oferta_validade_final_hora: this.oferta_validade_final_hora,
      // oferta_multiplo: this.oferta_multiplo,
      descricao: this.descricao,
      importado: this.importado,
      fabricacao: this.fabricacao,
      marca: this.marca,
      embalagem: this.embalagem,
      peso_liquido: this.peso_liquido,
      unidade_peso_liquido: this.unidade_peso_liquido,
      forma_venda: this.forma_venda,
      categories: this.categories,
      keywords: this.keywords,
      image_subtitle: this.image_subtitle,
      sem_limite: this.sem_limite,
      limite_minimo_estoque: this.limite_minimo_estoque,
      vivino_code: this.vivino_code,
      vivino_safra: this.vivino_safra,
      subtitulo: this.subtitulo,
      relevancia: this.relevancia,
      ckFrete: this.ckFrete,
      ckChangePrice: this.ckChangePrice,
      refrigerado: this.refrigerado,
      forma_venda_mostra: this.forma_venda_mostra,
      codigo_interno: this.codigo_interno,
    });
  }

  onUnlimitedStock(): void {
    if (this.estoque_bk != null) {
      this.estoque.setValue(this.estoque_bk);
      this.estoque_bk = null;
    } else {
      this.estoque_bk = this.estoque.value;
      this.estoque.setValue(null);
    }
    this.onChangeDetail();
  }

  onKeyCodbarra(ev): void {
    let cod = ev.target.value;
    if (cod && cod.length == 23 && this.loadingProduct == false) {
      this.onSearchProduct();
    }
  }

  toogleDescribe(): void {
    this.describeVisible = !this.describeVisible;
  }

  onTabClick(t) {
    this.tab = t;
  }

  onCancelRegister() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.getProductID(this._id);
      }
    });
  }

  onChangePrice() {
    this.productOffersItem.setNormalPrice(this.preco.value);
    this.onChangeDetail();
  }

  // updatePerc() {
  //   if (this.preco.value == undefined) {
  //     this.preco.setValue(0);
  //   }

  //   if (this.oferta_preco.value != undefined && this.preco.value > 0) {
  //     if (parseFloat(this.preco.value) > parseFloat(this.oferta_preco.value)) {
  //       this.oferta_off = parseFloat(
  //         (
  //           100 -
  //           (parseFloat(this.oferta_preco.value) * 100) /
  //             parseFloat(this.preco.value)
  //         ).toFixed(0)
  //       );
  //     } else {
  //       this.oferta_off = 0;
  //     }
  //   } else {
  //     this.oferta_preco.setValue(0);
  //     this.oferta_off = 0;
  //   }

  //   this.onChangeDetail();
  // }

  onBack() {
    this.navigation.back();
  }

  onChangeDetail() {
    this.changeDetail = true;
  }

  onChangeDepartamento() {
    this.changeDepartamentos = true;
    this.onChangeDetail();
  }

  onChangeCodBarra() {
    this.onChangeDetail();
  }

  // selectedDTInicio() {
  //   if (this.option_validade_inicial.value == 'H') {
  //     /*
  //     let dt = new Date()
  //     alert(dt)
  //     alert(dt.getFullYear()+' '+dt.getMonth()+' '+dt.getDate())
  //     alert(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes()))
  //     alert(AppFormat.nowUTC())
  //     alert(dt.toUTCString())
  //     */

  //     this.oferta_validade_inicial.setValue(AppFormat.nowUTCMoment());
  //     //this.oferta_validade_inicial.setValue(new Date())
  //   }
  //   this.onChangeDetail();
  // }

  onSearchProduct(): void {
    let cod = (<HTMLInputElement>(
      document.getElementById('codbarra')
    )).value.replace(/\D/g, '');

    if (cod != '' && cod != null && cod != undefined) {
      this._codbarra = cod;
      this.getProductCodbar(cod);
    }
  }

  convertUnidade(u): string {
    if (u == '' || u == null || u == undefined) return '';
    let pg_unidade_peso_liquido = '';
    switch (u.toLowerCase()) {
      case 'g':
      case 'grama(s)':
      case 'gramas':
        pg_unidade_peso_liquido = 'g';
        break;
      case 'kg':
      case 'k':
      case 'guilograma(s)':
      case 'guilogramas':
        pg_unidade_peso_liquido = 'kg';
        break;
      case 'l':
      case 'litro(s)':
      case 'litros':
        pg_unidade_peso_liquido = 'l';
        break;
      case 'ml':
      case 'mililitro(s)':
      case 'mililitros':
        pg_unidade_peso_liquido = 'ml';
        break;
    }
    return pg_unidade_peso_liquido;
  }

  newProduct(cod): void {
    this.initProduct();

    this.product['is_owner'] = true;
    this.product['flag_foto'] = 'E';
    this.gallery = [];

    this.codbarra.setValue(cod);

    this.isView = false;
    this.step = 2;
  }

  getProductID(cod: number): void {
    this.loadingProduct = true;
    this.errorFindCodbar = false;
    this.isView = false;

    this.initProduct();

    this._productService.getProductID(cod).subscribe((res) => {
      this.resProduct(res, cod);
    });
  }

  getProductCodbar(cod: string): void {
    this.loadingProduct = true;
    this.errorFindCodbar = false;
    this.isView = false;

    this.initProduct();

    this._productService.getProductCodbar(cod).subscribe((res) => {
      this.resProduct(res, cod);
    });
  }

  getTreeSubcategoria(arr) {
    //this.product.categories[i].subcategories
    let ret = [];

    for (let j in arr) {
      let arr_sub =
        arr[j]['subcategorias'] && arr[j]['subcategorias'].length > 0
          ? this.getTreeSubcategoria(arr[j]['subcategorias'])
          : [];

      ret.push(
        new FormGroup({
          subcategoria: new FormControl(arr[j].idsubcategoria),
          showText: new FormControl(false),
          list: new FormControl([]),
          subcategorias: new FormArray(arr_sub),
        })
      );
    }

    return ret;
  }

  loadCategoria(arr) {
    this.categories.clear();
    this.changeDepartamentos = false;

    for (let i in arr) {
      let arr_sub =
        arr[i].subcategorias && arr[i].subcategorias.length > 0
          ? this.getTreeSubcategoria(arr[i].subcategorias)
          : [];

      let frmCategoria = new FormGroup({
        categoria: new FormControl(arr[i].idcategoria),
        list: new FormControl([]),
        subcategorias: new FormArray(arr_sub),
        showText: new FormControl(false),
      });

      this._categoryService
        .getSubcategoriesFrom(arr[i].idcategoria)
        .subscribe((res) => {
          if (res.subcategorias) {
            frmCategoria.controls.list.setValue(res.subcategorias);
          }
        });

      this.categories.push(frmCategoria);
    }
  }

  resProduct(res, cod) {
    //console.log(res)
    if (res['success'] == true) {
      this.product = res;

      //carrega as ofertas se tiver do produto
      this.productOffersItem.loadData(this.product.idproduto_estabelecimento);

      //edit all
      this.preco.setValue(this.product.preco);

      this.productOffersItem.setNormalPrice(this.product.preco);

      this.estoque_bk = null;

      if (this.product.estoque > 0) {
        this.estoque.setValue(this.product.estoque);
      } else {
        this.estoque.setValue(null);
      }

      this.sem_limite.setValue(this.product.estoque_infinito == 'S');

      if (this.product.limite_minimo_estoque >= 0) {
        this.limite_minimo_estoque.setValue(this.product.limite_minimo_estoque);
      } else {
        this.limite_minimo_estoque.setValue(null);
      }

      if (this.product.max_pr_cliente >= 0) {
        this.max_pr_cliente.setValue(this.product.max_pr_cliente);
      } else {
        this.max_pr_cliente.setValue(null);
      }

      this.codbarra.setValue(this.product.codbarra);

      this.ckStatus.setValue(this.product.status == 'A' ? true : false);
      this.ckAmadurecimento.setValue(
        this.product.flag_amadurecimento == 'S' ? true : false
      );

      // edit only owner
      this.importado.setValue(this.product.importado == 'S' ? true : false);
      this.fabricacao.setValue(this.product.fabricacao);

      this.descricao.setValue(this.product.descricao);

      this.detalhe.setValue(this.product.detalhe);

      this.keywords.setValue(this.product.keywords);

      this.loadCategoria(this.product.categories);

      this.codigo_interno.setValue(this.product.codigo_interno);

      this.marca.setValue(this.product.marca);
      this.embalagem.setValue(this.product.embalagem);

      this.forma_venda.setValue(this.product.forma_venda);
      this.forma_venda_mostra.setValue(this.product.forma_venda_mostra);

      this.vivino_code.setValue(this.product.vivino_code);
      this.vivino_safra.setValue(this.product.vivino_safra);

      this.subtitulo.setValue(this.product.subtitulo);

      this.relevancia.setValue(this.product.relevancia);

      this.refrigerado.setValue(this.product.refrigerado == 'S' ? true : false);

      this.ckFrete.setValue(this.product.frete_gratis == 'S' ? true : false);
      this.ckChangePrice.setValue(
        this.product.mudar_preco == 'S' ? true : false
      );

      this.peso_liquido.setValue(this.product.peso_liquido);
      this.unidade_peso_liquido.setValue(
        this.convertUnidade(this.product.unidade_peso_liquido)
      );

      if (this.product.detalhe != '') {
        this.describeVisible = true;
      }

      if (
        this.product.estoque <= this.lower_stock &&
        this.product.estoque > 0
      ) {
        this.hasLowerStoke = true;
      }
      if (this.product.estoque == 0) {
        this.hasOutOfStock = true;
      }

      /*
      // ofertas
      if (this.product.oferta) {
        this.hasOffer = true;
        this.ckPromocao.setValue(true);

        this.oferta_preco.setValue(this.product.oferta.preco);

        this.oferta_obs.setValue(this.product.oferta.obs);

        this.oferta_multiplo.setValue(this.product.oferta.multiplo);

        if (
          this.product.oferta.comprando &&
          this.product.oferta.comprando > 0
        ) {
          this.oferta_comprando.setValue(this.product.oferta.comprando);
        } else {
          this.oferta_comprando.setValue(null);
        }

        this.oferta_off = parseFloat(
          (
            100 -
            (this.product.oferta.preco * 100) / this.product.preco
          ).toFixed(0)
        );

        let validade_inicial = this.product.oferta.validade_inicial.split(' ');
        if (validade_inicial.length > 0) {
          this.oferta_validade_inicial.setValue(
            AppFormat.dateYMDUTCMoment(validade_inicial[0])
          );
          this.oferta_validade_inicial_hora.setValue(validade_inicial[1]);
        }

        let validade_final = this.product.oferta.validade_final.split(' ');
        if (validade_final.length > 0) {
          this.oferta_validade_final.setValue(
            AppFormat.dateYMDUTCMoment(validade_final[0])
          );
          this.oferta_validade_final_hora.setValue(validade_final[1]);
        }

        this.option_validade_inicial.setValue('D');
        this.option_validade_final.setValue('D');

        if (this.max_pr_cliente.value == null) {
          if (this.product.oferta.max_pr_cliente >= 0) {
            this.max_pr_cliente.setValue(this.product.oferta.max_pr_cliente);
          } else {
            this.max_pr_cliente.setValue(null);
          }
        }
      } else {
        this.ckPromocao.setValue(false);

        this.oferta_preco.setValue(0);

        this.oferta_obs.setValue('');

        this.oferta_off = 0;

        this.oferta_multiplo.setValue('N');

        this.oferta_validade_inicial.setValue(null);
        this.oferta_validade_final.setValue(null);

        this.oferta_validade_inicial_hora.setValue('00:00:00');
        this.oferta_validade_final_hora.setValue('23:59:59');

        this.option_validade_inicial.setValue('');
        this.option_validade_final.setValue('');

        this.oferta_comprando.setValue(null);
      }
      */

      this.gallery = this.product.images;

      if (this.gallery && this.gallery.length > 0) {
        this.numberPhoto = this.gallery.length;
        for (let i in this.gallery) this.gallery[i].hash = AppFormat.makeid(3);
        this.selectPhoto(this.gallery[0], 0);
      }

      this.isView = this.product.is_owner != true;
      this.step = 2;
    } else {
      this.errorFindCodbar = true;

      setTimeout(() => {
        this.newProduct(cod);
      }, 1000);
    }
    this.loading = false;
    this.loadingProduct = false;
  }

  produtoValid() {
    let has = true;

    let msg = [];

    if (
      (this.preco.invalid && (this.preco.dirty || this.preco.touched)) ||
      this.preco.value == '' ||
      this.preco.value == undefined ||
      this.preco.value == null
    ) {
      msg.push('Você precisa preencher o valor do produto!');
      has = false;
    }

    /*
    if ((this.estoque.invalid && (this.estoque.dirty || this.estoque.touched)) || this.estoque.value == '' || this.estoque.value == undefined || this.estoque.value == null) {
      msg.push('Você precisa preencher a quantidade em estoque do produto!');
      has = false
    }
    */

    if (
      (this.codbarra.invalid &&
        (this.codbarra.dirty || this.codbarra.touched)) ||
      this.codbarra.value == '' ||
      this.codbarra.value == undefined ||
      this.codbarra.value == null
    ) {
      msg.push('Você precisa preencher o código de barra do produto!');
      has = false;
    }

    for (let i in this.categories.controls) {
      let fGroup = <FormGroup>this.categories.controls[i];

      let categoria = <FormControl>fGroup.controls.categoria;
      if (
        (categoria.invalid && (categoria.dirty || categoria.touched)) ||
        categoria.value == '' ||
        categoria.value == null
      ) {
        msg.push('Você precisa selecionar a categoria!');
        has = false;
      }

      let subcategorias = <FormArray>fGroup.controls.subcategorias;
      for (let j in subcategorias.controls) {
        let fsGroup = <FormGroup>subcategorias.controls[j];

        let subcategoria = <FormControl>fsGroup.controls.subcategoria;
        if (
          (subcategoria.invalid &&
            (subcategoria.dirty || subcategoria.touched)) ||
          subcategoria.value == '' ||
          subcategoria.value == null
        ) {
          msg.push('Você precisa selecionar a subcategoria!');
          has = false;
        }
      }
    }

    if (!this.isView) {
      if (
        (this.descricao.invalid &&
          (this.descricao.dirty || this.descricao.touched)) ||
        this.descricao.value == '' ||
        this.descricao.value == null
      ) {
        msg.push('Você precisa preencher a descrição!');
        has = false;
      }
    }

    if (msg.length > 0) {
      Swal.fire('Ops!', msg.join('<br>'), 'error');
    }

    return has;
  }

  // ofertaValid() {
  //   let has = true;

  //   let msg = [];

  //   if (this.ckPromocao.value) {
  //     if (
  //       this.oferta_obs.value != '' ||
  //       this.oferta_validade_inicial.value != '' ||
  //       this.oferta_validade_final.value != ''
  //     ) {
  //       //console.log(this.oferta_validade_inicial.invalid, this.oferta_validade_inicial.dirty, this.oferta_validade_inicial.touched, this.oferta_validade_inicial.value)
  //       if (
  //         (this.oferta_preco.invalid &&
  //           (this.oferta_preco.dirty || this.oferta_preco.touched)) ||
  //         this.oferta_preco.value == '' ||
  //         this.oferta_preco.value == null ||
  //         this.oferta_preco.value == 0
  //       ) {
  //         msg.push('Você precisa preencher o preço promocional!');
  //         has = false;
  //       }

  //       if (
  //         (this.oferta_validade_inicial.invalid &&
  //           (this.oferta_validade_inicial.dirty ||
  //             this.oferta_validade_inicial.touched)) ||
  //         this.oferta_validade_inicial.value == '' ||
  //         this.oferta_validade_inicial.value == null
  //       ) {
  //         msg.push('Você precisa preencher uma data inicial da oferta válida!');
  //         has = false;
  //       }

  //       if (
  //         (this.oferta_validade_final.invalid &&
  //           (this.oferta_validade_final.dirty ||
  //             this.oferta_validade_final.touched)) ||
  //         this.oferta_validade_final.value == '' ||
  //         this.oferta_validade_final.value == null
  //       ) {
  //         msg.push('Você precisa preencher uma data final da oferta válida!');
  //         has = false;
  //       }

  //       if (msg.length > 0) {
  //         Swal.fire('Ops!', msg.join('<br>'), 'error');
  //       }
  //     }
  //   }

  //   return has;
  // }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    Swal.fire('Salvo!', 'O produto foi salvo', 'success');
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  getListSubcategorias(frm: FormGroup) {
    let subcategorias = null;
    let subcategoria = frm.controls.subcategoria;
    if (
      subcategoria.value != '' &&
      subcategoria.value != null &&
      subcategoria.value != undefined
    ) {
      subcategorias = {
        idsubcategoria: subcategoria.value,
        subcategorias: [],
      };
      if (frm.controls.subcategorias) {
        let arr = <FormArray>frm.controls.subcategorias;
        for (let j in arr.controls) {
          let fsGroup = <FormGroup>arr.controls[j];

          let list = this.getListSubcategorias(fsGroup);
          if (list != null) {
            subcategorias['subcategorias'].push(list);
          }
        }
      }
    }
    return subcategorias;
  }

  onSubmit() {
    if (this.produtoValid()) {
      // if (!this.ofertaValid()) return false;

      // let dtinicial,
      //   dtfinal = '';
      // if (
      //   this.ckPromocao.value &&
      //   this.oferta_validade_inicial.value != null &&
      //   typeof this.oferta_validade_inicial.value === 'object'
      // ) {
      //   dtinicial = this.oferta_validade_inicial.value.format('YYYY-MM-DD');
      // } else {
      //   dtinicial = this.oferta_validade_inicial.value;
      // }

      // if (
      //   this.ckPromocao.value &&
      //   this.oferta_validade_final.value != null &&
      //   typeof this.oferta_validade_final.value === 'object'
      // ) {
      //   dtfinal = this.oferta_validade_final.value.format('YYYY-MM-DD');
      // } else {
      //   dtfinal = this.oferta_validade_final.value;
      // }

      if (this.forma_venda.value == 'U') {
        this.forma_venda_mostra.setValue('U');
      }

      let data = {
        preco: this.preco.value,
        estoque: this.estoque.value,
        estoque_infinito: this.sem_limite.value ? 'S' : 'N',
        limite_minimo_estoque: this.limite_minimo_estoque.value,
        keywords: this.keywords.value,
        max_pr_cliente: this.max_pr_cliente.value,
        // oferta_preco: this.ckPromocao.value ? this.oferta_preco.value : 0,
        // oferta_validade_inicial: dtinicial,
        // oferta_validade_inicial_hora: this.oferta_validade_inicial_hora.value,
        // oferta_validade_final: dtfinal,
        // oferta_validade_final_hora: this.oferta_validade_final_hora.value,
        // oferta_obs: this.oferta_obs.value,
        // oferta_max_pr_cliente: this.max_pr_cliente.value,
        // oferta_comprando: this.oferta_comprando.value,
        // oferta_multiplo: this.oferta_multiplo.value,
        forma_venda: this.forma_venda.value,
        forma_venda_mostra: this.forma_venda_mostra.value,
        detalhe: this.detalhe.value,
        descricao: this.descricao.value,
        fotos: this.gallery,
        vivino_code: this.vivino_code.value,
        vivino_safra: this.vivino_safra.value,
        subtitulo: this.subtitulo.value,
        relevancia: this.relevancia.value,
        codigo_interno: this.codigo_interno.value,
        frete_gratis: this.ckFrete.value ? 'S' : 'N',
        status: this.ckStatus.value ? 'A' : 'I',
        flag_amadurecimento: this.ckAmadurecimento.value ? 'S' : 'N',
        mudar_preco: this.ckChangePrice.value ? 'S' : 'N',
        refrigerado: this.refrigerado.value ? 'S' : 'N',
      };

      if (this.product.idproduto_geral > 0) {
        data['idproduto_geral'] = this.product.idproduto_geral;
      }

      let categorias = [];
      for (let i in this.categories.controls) {
        let fGroup = <FormGroup>this.categories.controls[i];

        let categoria = <FormControl>fGroup.controls.categoria;

        let subcategorias = [];
        let subcategories = <FormArray>fGroup.controls.subcategorias;
        for (let j in subcategories.controls) {
          let fsGroup = <FormGroup>subcategories.controls[j];
          let list = this.getListSubcategorias(fsGroup);
          if (list) {
            subcategorias.push(list);
          }
        }
        if (subcategorias.length > 0) {
          categorias.push({
            idcategoria: categoria.value,
            subcategorias: subcategorias,
          });
        }
      }
      data['categorias'] = categorias;

      if (!this.isView) {
        // other fields
        data['marca'] = this.marca.value;
        data['embalagem'] = this.embalagem.value;
        data['peso_liquido'] = this.peso_liquido.value;
        data['unidade_peso_liquido'] = this.unidade_peso_liquido.value;

        if (this.product.idproduto_geral == 0) {
          data['codbarra'] = this.codbarra.value;
        }

        data['fabricacao'] = this.fabricacao.value;
        data['importado'] = this.importado.value ? 'S' : 'N';
      }

      this.saving();

      //console.log(data)

      this.storeProduct(data);
    }
    return null;
  }

  storeProduct(data) {
    this._productService.store(data).subscribe(
      (res) => {
        if (res['success']) {
          if (this.product.idproduto_estabelecimento == 0) {
            this.product.idproduto_estabelecimento =
              res['idproduto_estabelecimento'];
            this.productOffersItem.loadData(
              this.product.idproduto_estabelecimento
            );
          }

          this.product['idproduto_geral'] = res['idproduto_geral'];
          this._id = res['idproduto_geral'];

          if (this.changeDepartamentos) {
            this.loadCategoria(res['categories']);
          }

          /*
        if (!this.isView) {
          this.isView = true
        }
        */
          if (this.uploader.queue.length > 0) {
            this.product['flag_foto'] = 'E';
            this.sendImages();
          } else {
            this.saveComplete();
          }
        } else {
          this.saveError();
        }
      },
      (error) => {
        this.saveError();
      }
    );
  }

  sendImages(): void {
    this.uploader.setOptions({
      url:
        this._apiService.API_PATH + 'product/' + this.codbarra.value + '/image',
      authTokenHeader: 'Authorization',
      authToken: 'Bearer ' + this._apiService.getAccessToken(),
    });

    this.uploader.uploadAll();
  }
}
